export const getFrontOfHouseAction = (status) => ({
  confirmed: "kitchen",
  ready: "served",
  served: "closed",
}[status] || null);

export const getPreparationProgress = (order) => {
  const ready = Number(order?.ready_items) || 0;
  const total = Number(order?.active_items) || 0;
  return ready > 0 && ready < total
    ? `${ready} article${ready > 1 ? "s" : ""} prêt${ready > 1 ? "s" : ""} sur ${total}`
    : "";
};

export const getKitchenActions = (ticket, { canConvert, canUpdate }) => {
  const active = ["sent_to_kitchen", "in_preparation", "ready"].includes(ticket.flow_status);
  return {
    canProduce: active && canConvert && ticket.line_status !== "ready" &&
      ticket.status === "ready_for_production" && Number(ticket.production_unit_id) > 0,
    canMarkReady: active && canUpdate && ticket.line_status !== "ready" &&
      ["converted", "not_required"].includes(ticket.status),
    canCancel: canUpdate && ["sent_to_kitchen", "in_preparation"].includes(ticket.flow_status) &&
      !ticket.production_log_id,
  };
};
